import { createFileRoute } from "@tanstack/react-router";
import { TextCampaignList } from "@/components/text-banking/TextCampaignList";

export const Route = createFileRoute("/_app/_/text-banking/")({
	component: TextBankingIndexPage,
});

/**
 * Text Banking landing page.
 *
 * 2026-05-24 (Andrew): the top-of-page 10DLC RegistrationBanner has
 * been removed. The 10DLC gate now fires inline inside the campaign
 * creation flow (`TextCreateFlow`), where it directs unregistered
 * users to email support@americamajority.org. The RegistrationBanner
 * component is preserved in `components/text-banking/` for reuse.
 */
function TextBankingIndexPage() {
	return (
		<div className="p-6 space-y-6">
			<TextCampaignList />
		</div>
	);
}
